import React from 'react';
    import { Link } from 'react-router-dom';
    import * as FiIcons from 'react-icons/fi';
    import SafeIcon from '../common/SafeIcon';

    const { FiInstagram, FiMail } = FiIcons;

    const Footer = () => {
      const navigation = [
        { name: 'Home', href: '/' },
        { name: 'About', href: '/about' },
        { name: 'Services', href: '/services' },
        { name: 'Courses', href: 'https://resources.divorcewithdirection.co.uk', isExternal: true },
        { name: 'Contact', href: '/contact' }
      ];

      return (
        <footer className="bg-white border-t border-gray-100">
          <div className="max-w-6xl mx-auto px-6 lg:px-8 py-16">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              <div className="lg:col-span-2">
                <Link to="/" className="inline-block mb-6">
                  <h3 className="text-2xl font-canela font-medium text-gray-900"> Divorce with Direction </h3>
                </Link>
                <p className="text-gray-600 font-inter leading-relaxed mb-6 max-w-md">
                  Supporting women through divorce with compassion, clarity, and confidence. Professional coaching to help you navigate this transition with strength.
                </p>
                <div className="flex space-x-4">
                  <a 
                    href="https://www.instagram.com/divorcewithdirection/" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="w-10 h-10 bg-sage-100 rounded-full flex items-center justify-center text-sage-600 hover:bg-sage-200 transition-colors"
                  >
                    <SafeIcon icon={FiInstagram} className="h-5 w-5" />
                  </a>
                  <Link to="/contact" className="w-10 h-10 bg-sage-100 rounded-full flex items-center justify-center text-sage-600 hover:bg-sage-200 transition-colors">
                    <SafeIcon icon={FiMail} className="h-5 w-5" />
                  </Link>
                </div>
              </div>

              <div>
                <h4 className="text-lg font-inter font-semibold text-gray-900 mb-6">Navigation</h4>
                <nav className="space-y-3">
                  {navigation.map((item) => (
                    item.isExternal ? (
                      <a 
                        key={item.name} 
                        href={item.href} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="block text-gray-600 hover:text-sage-600 font-inter transition-colors"
                      >
                        {item.name}
                      </a>
                    ) : (
                      <Link 
                        key={item.name} 
                        to={item.href} 
                        className="block text-gray-600 hover:text-sage-600 font-inter transition-colors"
                      >
                        {item.name}
                      </Link>
                    )
                  ))}
                </nav>
              </div>
            </div>

            <div className="mt-12 pt-8 border-t border-gray-100 flex flex-col md:flex-row justify-between items-center">
              <p className="text-gray-500 text-sm font-inter"> © 2025 Divorce with Direction. All rights reserved. </p>
              <div className="flex space-x-6 mt-4 md:mt-0">
                <Link to="/privacy-policy" className="text-gray-500 hover:text-sage-600 text-sm font-inter transition-colors"> Privacy Policy </Link>
                <Link to="/terms-of-service" className="text-gray-500 hover:text-sage-600 text-sm font-inter transition-colors"> Terms of Service </Link>
              </div>
            </div>
          </div>
        </footer>
      );
    };

    export default Footer;